import { render, staticRenderFns } from "./SkinSensitiveWarningModal.vue?vue&type=template&id=13654c04&scoped=true"
import script from "./SkinSensitiveWarningModal.vue?vue&type=script&lang=js"
export * from "./SkinSensitiveWarningModal.vue?vue&type=script&lang=js"
import style0 from "./SkinSensitiveWarningModal.vue?vue&type=style&index=0&id=13654c04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13654c04",
  null
  
)

export default component.exports